export default theme => ({
  button: { border: '2px solid' },
});
